export default {
  "fr": {
    "session": {
      "error_internalserver": {
        "goback": "Retour",
        "subtitle": "Oops, une erreur inattendue semble s'être produite.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Retour",
        "subtitle": "Désolé, la page que vous recherchez est introuvable.",
        "title": "404"
      },
      "expired": {
        "text": "Votre session a expiré pour cause d'inactivité. Pour des raisons de sécurité, vous devez vous connecter à nouveau. \n\nCliquer sur OK pour être redirigé vers l'écran de connexion.",
        "title": "Session expiré"
      },
      "logout_impersonate": {
        "text": "Une action de déconnexion a été déclenchée pendant l'imitation.",
        "title": "Imitation arrêtée"
      },
      "noaccess": {
        "text": "Vous n'avez actuellement accès à cette page, vous serez redirigé vers la page d'accueil'.",
        "title": "Accès refusé pour {subdomain}"
      }
    }
  }
}